<template>
  <div
    id="scrolldata"
    v-loading="isloading"
    :class="
      carddata != null
        ? carddata.length > 0
          ? ''
          : 'card_content_backimage'
        : ''
    "
  >
    <el-row :gutter="0">
      <slot />
      <!-- @click="cardset()" -->

      <div
        v-for="(msg, index) in carddata"
        v-if="!msg.isdisabled && msg.hidden != true"
        :key="index"
        class="card_list card_list_big"
        :class="[msg.isflicker ? 'warnShadow' : msg.ischecked ? 'checkCss' : '', msg.disableCheck && 'disableCheck']"
        @click.stop="() => !msg.disableCheck && cardset(msg)"
      >
        <!-- :class="[msg.ischecked ? 'checkCss' : '']" -->
        <!-- <div :class="[msg.isflicker ? 'warnShadow' : '']" class="shadow_box"></div> -->
        <template>
          <div class="card_header">
            {{ doParentGpnos(msg) }}
            <template>
              <div
                v-if="msg.DeviceRole !== DEVICE_ROLE.TianMu && !getdeviceImageStatus(msg, '0X0100', '0')"
                style="z-index: 1; position: absolute"
              >
                <img
                  v-if="msg.ProtocolTypeList&&msg.ProtocolTypeList.length === 1"
                  style="float: left; margin: 4px 0"
                  :title="msg.ProtocolTypeList&&msg.ProtocolTypeList[0].Name"
                  :src="catchRequireErr(() => require('@static/img/property/property_' + msg.ProtocolTypeList[0].Id + '.png'))"
                >
                <img
                  v-else-if="msg.ProtocolTypeList&&msg.ProtocolTypeList.length >= 2"
                  style="float: left; margin: 4px 0"
                  title="MIX"
                  :src="require('@static/img/property/property_3.png')"
                >

                <div class="car_statusInfo">
                  <template v-for="model in msg.StatusInfo">
                    <!-- 显示的设备的主状态 -->
                    <template v-if="model.IsTop && (model.StatusType.toUpperCase().substring(0, 4) == '0X05' || model.StatusType.toUpperCase().substring(0, 6) == '0X0200') && (model.ChannelId === 65535) && (msg.ClassSku.toUpperCase() != '0X001C3003')">
                      <div
                        v-if="model.StatusType.toUpperCase().substring(0, 4) == '0X05'"
                        :title="$t(&quot;devicecard.movement&quot;)"
                        class="statusCssPerson"
                        :class="{ statusCssPersonNone: model.Value1 != '1' }"
                        style="display: flex"
                      >
                        <template v-if="model.Value1 == '1'">
                          <img
                            :title="$t('devicecard.movement')"
                            class="state_img"
                            src="../../assets/img/icon_type05.png"
                          >
                        </template>
                        <template v-else>
                          <img
                            :title="$t('devicecard.movement')"
                            class="state_img"
                            src="../../assets/img/icon_type06c.png"
                          >
                        </template>
                        <span>&nbsp;{{ cardLightInforValue(model) }}</span>
                      </div>
                      <div
                        v-if="model.StatusType.toUpperCase().substring(0, 4) == '0X02'"
                        class="card_state"
                      >
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X02'
                          "
                          :title="$t('sceneCard.lightSwitch')"
                        >
                          <template v-if="msg.ChildId == 65535">
                            <template v-if="model.Value1 == '1'">
                              <span
                                :title="$t('devicecard.switchstatus')"
                                class="on"
                              >{{ model.Value }}</span>
                            </template>
                            <template v-else>
                              <span
                                :title="$t('devicecard.switchstatus')"
                                class="off"
                              >{{ model.Value }}</span>
                            </template>
                          </template>
                          <template v-else>
                            <template
                              v-if="
                                model.Value1 == '1' &&
                                  model.ChannelId == msg.ChildId
                              "
                            >
                              <span
                                :title="$t('devicecard.switchstatus')"
                                class="on"
                              >{{ model.Value }}</span>
                            </template>
                            <template v-else>
                              <span
                                :title="$t('devicecard.switchstatus')"
                                class="off"
                              >{{ model.Value }}</span>
                            </template>
                          </template>
                        </template>
                      </div>
                    </template>

                    <template v-if="model.StatusType.toUpperCase() == '0X140A' && model.Value1 !== '254'">
                      <div
                        :key="model.TimeStamp"
                        class="card_state"
                        style="margin-top:2px;"
                      >
                        <img
                          :title="showHclTitle(model.Value1)"
                          :src="catchRequireErr(() => require('@static/img/hcl/icon-type-'+model.Value1+'.png'))"
                          style="width:40px;"
                        >
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>

            <div
              v-if="msg.DeviceRole !== DEVICE_ROLE.TianMu && !getdeviceImageStatus(msg, '0X0100', '0')"
              class="card_isbind"
              :class="is_check? 'card_isbind_check' : ''"
            >
              <template v-if="msg['IsBind'] == false">
                <img
                  class="link_img"
                  style="height: 13px"
                  src="../../assets/img/isbind/isbind_false.png"
                >
              </template>
              <!-- //第三方设备icon -->
              <template
                v-else-if="
                  typeof msg['ClassSku'] == 'string' &&
                    msg['ClassSku']
                      .toUpperCase()
                      .indexOf($store.state.thirdSkuMarkTag.toUpperCase()) >= 0
                "
              >
                <!-- <img
                  class="link_img"
                  style="height: 13px"
                  src="../../assets/img/isbind/isbind_third.png"
                > -->
                <!-- <div class="third">{{ 'Third' }}</div> -->
              </template>
            </div>

            <el-checkbox
              v-if="is_check && !msg.disableCheck"
              v-model="msg.ischecked"
              :class="isradio ? 'check_one' : 'card_check'"
              :disabled="msg.isdisabled"
              class="card_check"
              @change="removeTree(msg)"
            />
            <slot name="delete" />
            <div
              class="card_header_msg"
              :class="{ grayImage: getdeviceImageStatus(msg, '0X0100', '0') }"
              :style="
                getdeviceImageStatus(msg, '0X0100', '0')
                  ? 'background:#e3e6ec!important;opacity: 0.6;'
                  : ''
              "
            >
              <!-- <div class="card_header_msg" :class="msg.IsBind ? 'real' : 'fake'"> -->
              <div class="card_left">
                <!-- 项目图片 -->
                <!-- <template v-if="msg.IconUrl">
									<img class="card_img" :class="(getdeviceImageStatus(msg, '0X02', '1')==true || getdeviceImageStatus(msg, '0X02', '1') == null)?'':'grayImage'" :src="'/static/device/icon/' + msg.IconUrl" />
								</template>
								<template v-else>
									<img class="card_img" src="../../assets/img/d_f2.png" />
								</template> -->
                <template v-if="getdeviceImageStatus(msg, '0X0100', '0')">
                  <img
                    v-if="$store.state.isLocalServer"
                    class="card_img"
                    :src="getClassSkuImage(msg, 'offline')"
                  >
                  <img
                    v-else
                    class="card_img"
                    :src="getImgUrlState(msg, 'offline')"
                  >
                </template>
                <template v-else-if="getdeviceImageStatus(msg, '0X02', '0') == true">
                  <img
                    v-if="$store.state.isLocalServer"
                    class="card_img"
                    :src="getClassSkuImage(msg, 'off')"
                  >
                  <img
                    v-else
                    class="card_img"
                    :src="getImgUrlState(msg, 'off')"
                  >
                </template>
                <template v-else>
                  <img
                    v-if="$store.state.isLocalServer"
                    class="card_img"
                    :src="getClassSkuImage(msg, 'on')"
                  >
                  <img
                    v-else
                    class="card_img"
                    :src="getImgUrlState(msg, 'on')"
                  >
                </template>
                <template>
                  <!-- <template v-if="msg.StatusCode!=null&&msg.StatusCode!=''">
										<img :title="$t('devicecard.offline')" v-if="!msg.IsOnline" class="link_img" src="../../assets/img/icon_type26.png" />
										<img :title="$t('devicecard.online')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x00'" class="link_img" src="../../assets/img/icon_type25.png" />
										<img :title="$t('devicecard.callpolice')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x01'" class="link_img" src="../../assets/img/icon_type02.png" />
										<img :title="$t('devicecard.malfunction')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x02'" class="link_img" src="../../assets/img/icon_type01.png" />
										<img :title="$t('devicecard.lifeto')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x03'" class="link_img" src="../../assets/img/icon_type03.png" />
									</template>
									<template v-else>
										<img :title="$t('devicecard.offline')" v-if="!msg.IsOnline" class="link_img" src="../../assets/img/icon_type26.png" />
										<img :title="$t('devicecard.online')" v-else class="link_img" src="../../assets/img/icon_type25.png" />
									</template> -->

                  <!-- {{getDeviceStateUrl(msg.StatusInfo, msg)}}
                  {{getDeviceStateTitle(msg.StatusInfo, msg)}}
                  <img
                    v-if="msg.StatusUrl != ''"
										:title="msg.StatusTitle"
										class="link_img"
										:src="msg.StatusUrl"
									/> -->

                  <template v-for="(model, kindex) in msg.StatusInfo">
                    <template
                      v-if="
                        model.StatusType == '0x0000' &&
                          model.Value1 != '0x0000' &&
                          model.Value1 != '0x0001'
                      "
                    >
                      <!-- && model.Value1 != '0x0001'" -->
                      <template
                        v-if="
                          model.Value1 != '--' &&
                            model.Value1 != '' &&
                            model.Value1 != null
                        "
                      >
                        <img
                          :key="kindex"
                          :title="
                            deiveStatusName(model.StatusType, model.Value1)
                          "
                          class="link_img"
                          :src="
                            catchRequireErr(() => require('@static/device/statusinfo/' +
                              model.StatusType +
                              '/icon_' +
                              model.StatusType +
                              '_' +
                              model.Value1 +
                              '.png'))
                          "
                        >
                        <!-- <img
													:key="kindex"
													:title="$t('devicecard.online')"
													v-if="model.Value1 == '0x0000'"
													class="link_img"
													src="../../assets/img/icon_type25.png"
												/>

												<img
                          :key="kindex"
                          :title="$t('devicecard.offline')"
                          v-else-if="model.Value1 == '0x0001'"
													class="link_img"
                          src="../../assets/img/icon_type26.png"
                        />

												<img
													:key="kindex"
													:title="$t('devicecard.callpolice')"
													v-else-if="model.Value1.substring(0, 4) == '0x01'"
													class="link_img"
													src="../../assets/img/icon_type02.png"
												/>
												<img
													:key="kindex"
													:title="$t('devicecard.malfunction')"
													v-else-if="model.Value1.substring(0, 4) == '0x02'"
													class="link_img"
													src="../../assets/img/icon_type01.png"
												/>
												<img
													:key="kindex"
													:title="$t('devicecard.lifeto')"
													v-else-if="model.Value1.substring(0, 4) == '0x03'"
													class="link_img"
													src="../../assets/img/icon_type03.png"
												/> -->
                      </template>
                      <!-- <template v-else>
												<img :key="kindex" :title="$t('devicecard.offline')" v-if="!msg.IsOnline" class="link_img" src="../../assets/img/icon_type26.png" />
												<img :key="kindex" :title="$t('devicecard.online')" v-else class="link_img" src="../../assets/img/icon_type25.png" />
											</template> -->
                    </template>
                    <!-- <template v-else-if="model.StatusType == '0x0100'">
                      <img :key="kindex" :title="$t('devicecard.offline')" v-if="model.Value1 == 0" class="link_img" src="../../assets/img/icon_type26.png" />
											<img :key="kindex" :title="$t('devicecard.online')" v-else class="link_img" src="../../assets/img/icon_type25.png" />
										</template> -->
                  </template>

                  <!-- <img v-if="state == 4" class="link_img" src="../../assets/img/icon_type04.png" /> -->

                  <!-- <i class="link_img icon-43" v-if="msg.StatusCode == '0x0000' && msg.IsOnline"></i>
									<i class="link_img icon-15" v-else-if="msg.StatusCode == '0x0000' && !msg.IsOnline"></i>
									<i class="link_img icon-15" v-else></i> -->
                  <!-- 故障 -->
                  <!-- <img class="link_img" v-if="msg.islink === true" src="../../assets/img/link.png" />
									<img class="link_img" v-else src="../../assets/img/nolink.png" /> -->
                </template>
              </div>

              <div class="card_right op_relative">
                <div class="card_input op_cardname" :class="msg.DeviceRole === DEVICE_ROLE.TianMu? 'op_cardname_tianmu' : ''">
                  <template v-if="msg.bleSignalPic != null && $store.state.signalStrengthConfig">
                    <deviceSignalVue
                      :max="msg.bleSignalPic.maxSignal"
                      :min="msg.bleSignalPic.minSignal"
                      :value="msg.bleSignalPic.valueSignal"
                      :title="msg.bleSignalPic.nameSignal"
                    />
                  </template>
                  <template v-if="msg.ChildId == 65535">
                    <div
                      v-show="!msg.flag"
                      class="card_title op_static text-ellipsis"
                      :title="msg.DeviceName"
                    >
                      {{ msg.DeviceName }}
                    </div>
                    <input
                      v-show="msg.flag"
                      v-model="msg.DeviceName"
                      type="text"
                      class="op_w130 op_static"
                      style="padding-right: 20px"
                      maxlength="32"
                      @focus="focusHandler($event)"
                      @blur="handleblur(msg, $event)"
                      @keyup.enter="handleEnter(msg, $event)"
                      @click.stop="onStop()"
                    >
                  </template>
                  <template v-else>
                    <div
                      v-show="!msg.flag"
                      class="card_title text-ellipsis op_static"
                      :title="msg.ChildName + '-' + msg.DeviceName"
                    >
                      {{ msg.ChildName }}-{{ msg.DeviceName }}
                    </div>
                    <input
                      v-show="msg.flag"
                      v-model.trim="msg.ChildName"
                      type="text"
                      class="op_w130 op_static"
                      style="padding-right: 20px"
                      @focus="focusHandler($event)"
                      @blur="handleblur(msg, $event)"
                      @keyup.enter="handleEnter(msg, $event)"
                      @click.stop="onStop()"
                    >
                  </template>
                  <!-- <span
                    v-show="msg.flag"
                    class="modifyNameCss"
                    @click.stop="slelectModifyNameTag($event, msg)"
                  >▼</span> -->
                  <OppleAuth code="EditDevice" :force-show="$store.state.isPassPermission">
                    <el-button
                      v-if="!(is_check || noclick)"
                      type="text"
                      class="op_static"
                      icon="el-icon-edit"
                      @click.stop="edit(msg, $event)"
                    />
                  </OppleAuth>

                </div>
                 <!--新增天幕设备不显示-->
                <div
                  v-if=" msg.DeviceRole !== DEVICE_ROLE.TianMu && !getdeviceImageStatus(msg, '0X0100', '0') "
                  class="card_state_body"
                >
                  <ul class="card_state op_mt40">
                    <template v-for="model in msg.StatusInfo">
                      <li
                        v-if="
                          model.IsTop &&
                            model.StatusType.toUpperCase() != '0X0000' &&
                            model.StatusType.toUpperCase() != '0X0100' &&
                            (model.StatusType.toUpperCase().substring(0, 4) !=
                              '0X05' || (model.StatusType.toUpperCase().substring(0, 4) ===
                                '0X02' && model.ChannelId !== 65535)) && msg.ClassSku.toUpperCase() != '0X001C3003'
                            && 
                            !(!$store.state.signalStrengthConfig && model.StatusType.toUpperCase() === '0X1D01')
                        "
                      >
                        <template v-if="model.StatusType.toUpperCase() == '0X0102'">
                          <!-- uplink状态 -->
                          <img
                            title="uplink"
                            class="state_img"
                            src="../../assets/img/icon_type20.png"
                          >
                          <template v-if="model.Value == 1">
                            <em class="dot" />
                          </template>
                          <template v-else>
                            <em class="dot green_dot" />
                          </template>
                        </template>
                        <template v-if="model.StatusType.toUpperCase() == '0X0103'">
                          <!-- wifi状态 -->
                          <img
                            title="wifi"
                            class="state_img"
                            src="../../assets/img/icon_type21.png"
                          >
                          <template v-if="model.Value == 1">
                            <em class="dot" />
                          </template>
                          <template v-else>
                            <em class="dot green_dot" />
                          </template>
                        </template>
                        <template v-if="model.StatusType.toUpperCase() == '0X0104'">
                          <!-- ble状态 -->
                          <img
                            title="ble"
                            class="state_img"
                            src="../../assets/img/icon_type22_1.png"
                          >
                          <template v-if="model.Value == 1">
                            <em class="dot" />
                          </template>
                          <template v-else>
                            <em class="dot green_dot" />
                          </template>
                        </template>
                        <template v-if="model.StatusType.toUpperCase() == '0X0107'">
                          <!-- ble状态 -->
                          <img
                            title="ble"
                            class="state_img"
                            src="../../assets/img/icon_type22_2.png"
                          >
                          <template v-if="model.Value == 1">
                            <em class="dot" />
                          </template>
                          <template v-else>
                            <em class="dot green_dot" />
                          </template>
                        </template>
                        <template v-if="model.StatusType.toUpperCase() == '0X0105'">
                          <!-- dali状态 -->
                          <img
                            title="dali"
                            class="state_img"
                            src="../../assets/img/icon_type23.png"
                          >
                          <template v-if="model.Value == 1">
                            <em class="dot" />
                          </template>
                          <template v-else>
                            <em class="dot green_dot" />
                          </template>
                        </template>
                        <template v-if="model.StatusType.toUpperCase() == '0X0106'">
                          <!-- 485状态 -->
                          <img
                            title="485"
                            class="state_img"
                            src="../../assets/img/icon_type24.png"
                          >
                          <template v-if="model.Value == 1">
                            <em class="dot" />
                          </template>
                          <template v-else>
                            <em class="dot green_dot" />
                          </template>
                        </template>
                        <!-- <template v-if="model.StatusType.toUpperCase().substring(0, 4) == '0X02'" title="开关">
												<template v-if="msg.ChildId == 65535">
													<template v-if="model.Value1 == '1'">
														<span :title="$t('devicecard.switchstatus')" class="on">ON</span>
													</template>
													<template v-else>
														<span :title="$t('devicecard.switchstatus')" class="off">OFF</span>
													</template>
												</template>
												<template v-else>
													<template v-if="model.Value1 == '1' && model.ChannelId == msg.ChildId">
														<span :title="$t('devicecard.switchstatus')" class="on">ON</span>
													</template>
													<template v-else>
														<span :title="$t('devicecard.switchstatus')" class="off">OFF</span>
													</template>
												</template>
											</template> -->
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X03'
                          "
                        >
                          <!-- 亮度 -->
                          <img
                            :title="$t('devicecard.light')"
                            class="state_img"
                            src="../../assets/img/icon_type010.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X04'
                          "
                        >
                          <!-- 色温 -->
                          <img
                            :title="$t('devicecard.colortemperature')"
                            class="state_img"
                            src="../../assets/img/icon_type11.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X06'
                          "
                        >
                          <!-- 照度 -->
                          <img
                            :title="$t('devicecard.illuminance')"
                            class="state_img"
                            src="../../assets/img/icon_type07.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X07'
                          "
                        >
                          <!-- 温度 -->
                          <img
                            :title="$t('devicecard.temperature')"
                            class="state_img"
                            src="../../assets/img/icon_type08.png"
                          >
                        </template>
                       
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X08'
                          "
                        >
                          <!-- 湿度 -->
                          <img
                            :title="$t('devicecard.humidity')"
                            class="state_img"
                            src="../../assets/img/icon_type09.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X09'
                          "
                        >
                          <!-- 二氧化碳 -->
                          <img
                            :title="$t('devicecard.co2')"
                            class="state_img"
                            src="../../assets/img/icon_type12.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X0A'
                          "
                        >
                          <!-- pm2.5 -->
                          <img
                            :title="$t('devicecard.pm')"
                            class="state_img"
                            src="../../assets/img/icon_type13.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X0B'
                          "
                        >
                          <!-- tvoc -->
                          <span
                            title="tvoc"
                            class="tvoc_state"
                          >{{
                            model.Value
                          }}</span>
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X0C'
                          "
                        >
                          <!-- 功率 -->
                          <img
                            :title="$t('devicecard.power')"
                            class="state_img"
                            src="../../assets/img/icon_type17.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X0D'
                          "
                        >
                          <!-- 能耗 -->
                          <img
                            :title="$t('devicecard.energyconsumption')"
                            class="state_img"
                            src="../../assets/img/icon_type19.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X0E'
                          "
                        >
                          <!-- 剩余寿命 -->
                          <img
                            :title="$t('devicecard.remaininglife')"
                            class="state_img"
                            src="../../assets/img/icon_type18.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X0F'
                          "
                        >
                          <!-- 电机行程 -->
                          <img
                            :title="$t('devicecard.motortravel')"
                            class="state_img"
                            src="../../assets/img/icon_type16.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X10'
                          "
                        >
                          <!-- 电量 -->
                          <img
                            :title="$t('devicecard.electricity')"
                            class="state_img"
                            src="../../assets/img/icon_type14.png"
                          >
                        </template>
                        <template
                          v-if="
                            model.StatusType.toUpperCase().substring(0, 4) ==
                              '0X12'
                          "
                        >
                          <!-- 电机角度 -->
                          <img
                            :title="$t('devicecard.motorangle')"
                            class="state_img"
                            src="../../assets/img/icon_type15.png"
                          >
                        </template>
                        <template
                          v-if="
                            (model.StatusType.toUpperCase().substring(0, 4) ===
                              '0X02'&& model.ChannelId !== 65535) || 
                              model.StatusType.toUpperCase().substring(0, 4) !=
                              '0X01' &&
                              model.StatusType.toUpperCase().substring(0, 4) !=
                              '0X0B'&&
                              model.StatusType.toUpperCase().substring(0, 4) !=
                              '0X14'
                          "
                        >
                          <span>{{ cardLightInforValue(model) }}{{ model.ParaUnit }}</span>
                        </template>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
              <span
                v-if="msg.havecheck"
                class="have_state"
              >{{
                $t("devicecard.alreadycheck")
              }}</span>
            </div>
          </div>
        </template>

        <div
          class="card_msgs"
          :style="
            getdeviceImageStatus(msg, '0X0100', '0')
              ? 'background:#ebeff6!important;'
              : ''
          "
        >
          <ul
            :style="
              getdeviceImageStatus(msg, '0X0100', '0') ? 'opacity: 0.6;' : ''
            "
          >
            <!-- <li>
							{{ $t('devicecard.attributes') }}：
							<span>{{ msg.IsBind == false ? $t('devicecard.nobind') + '-' : '' }}{{ msg.DeviceTypeName }}</span>
						</li> -->
            <li>
              MAC：
              <span>{{ macformate(msg.Mac) }}</span>
            </li>
            <li
              class="text-ellipsis"
              :title="msg.ParentAreaNames"
            >
              {{ $t("devicecard.area") }}：
              <span>{{ msg.ParentAreaNames }}</span>
            </li>
          </ul>

          <div
            v-if="false"
            class="have_date"
          >
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('devicecard.dataing')"
              placement="bottom"
            >
              <!-- <img src="../../assets/img/date.png" /> -->
              <i class="icon-18" />
            </el-tooltip>
          </div>
          <div class="have_new" v-if="msg.DeviceRole !== DEVICE_ROLE.TianMu">
            <distinguish
              :msg="msg"
              @socket-handler="functionScoketsync_info_event"
            />
            <!--<img v-show="msg.havenew" src="../../assets/img/new.png" />
            <el-button @click.stop="know(msg)" :disabled="msg.IsBind == false" :class="{ eventNone: getdeviceImageStatus(msg, '0X0100', '0') }" :style="
                getdeviceImageStatus(msg, '0X0100', '0') ? 'opacity: 0.6;' : ''
              ">{{ $t("devicecard.identification") }}</el-button>-->
          </div>
        </div>
      </div>
    </el-row>
    <template v-if="dialogGroup">
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogGroup"
        class="dialogGroup choose_device"
        :before-close="handleClose"
      >
        <v-choose
          :areaid="replaceid"
          :showcount="false"
          :searchtype="1"
          :isreplace="true"
          @confirm="confirm"
        />
      </el-dialog>
    </template>

    <template v-if="card_set">
      <el-dialog
        :title="
          model.ChildName != ''
            ? model.ChildName + '-' + model.DeviceName
            : model.DeviceName
        "
        :visible.sync="card_set"
        class="card_dialog"
        :modal-append-to-body="false"
        :close-on-click-modal="!hasSelectChildDevice"
      >
        <button
          class="button_E330 buttonRefresh"
          :class="!isDoCardsetResresh ? 'button_eventNone_E330' : ''"
          @click="cardsetResresh"
        >
          {{ $t("devicecard.refresh") }}&nbsp;<i :class="!isDoCardsetResresh ? 'el-icon-time' : 'el-icon-refresh'" />
        </button>
        <div
          v-loading="$store.state.isloadingdetail"
          class="card_set"
        >
          <!-- <i @click="cardCloce" class="el-icon-close button_close"></i> -->
          <!-- <vuescroll> -->
          <el-scrollbar
            class="new_scrollbar"
            style="height: 100%"
          >
            <v-msg
              ref="cardsetObj"
              :devicemodel="model"
              :is-exist-gs-device="isExistGsDevice"
              @replacedevice="replacedevice"
              @removedevice="removedevice"
              @deletedevice="deletedevice"
              @dosuccess="dosuccess"
              @selectChildDevice="selectChildDevice"
            />
            <!-- </vuescroll> -->
          </el-scrollbar>
        </div>
      </el-dialog>
    </template>

    <!-- <template v-if="courseDialog">
      <el-dialog
        :modal-append-to-body="false"
        class="cousreing"
        :visible.sync="courseDialog"
        width="650px"
        :before-close="handleCloseSynCurrent"
      >
        <v-course :removecurrent="removecurrent" @backgroundDoCurrent="backgroundDoCurrent">
					<span slot="cousreTitle">{{ cousreTitle }}</span>
				</v-course>
        <v-cds
          :removecurrent="removecurrent"
          :area-tree-type="1"
          :searchtype="1"
          @backgroundDo="backgroundDoCurrent"
        >
          <span slot="cousreTitle">{{ $t("courseDataySync.current") }}</span>
        </v-cds>
      </el-dialog>
    </template> -->

    <template v-if="is_removetree">
      <el-dialog
        :modal-append-to-body="false"
        class="remove_tree_cont"
        :visible.sync="is_removetree"
        width="650px"
        :before-close="handleClose"
      >
        <div class="remove_tree">
          <div class="blue_header">
            <span>{{ $t("install.remveblock") }}</span>
          </div>
          <i
            class="el-icon-close text-button"
            @click="close"
          />
          <radio-tree
            class="limit_set"
            @getareaid="getareaid"
          />
          <el-button
            class="limite_button"
            @click="finsh"
          >
            {{
              $t("install.finsh")
            }}
          </el-button>
          <!-- <div class="limite_button" @click="finsh">{{ $t('install.finsh') }}</div> -->
        </div>
      </el-dialog>
    </template>
    <template v-if="otaWarnFlag">
      <el-dialog
        class="otaWarn_box"
        width="860px"
        :before-close="handleClose"
        :visible.sync="otaWarnFlag"
        :modal-append-to-body="false"
      >
        <otaUpdateDidalog 
          :move-type="moveType"
          :new-device-selected="newDeviceSelected"
          @closeDialog="setOtaWarnFlag" 
          @doRemoveArea="doRemoveArea" 
        />
      </el-dialog>
    </template>
    <!--<template v-if="imgDialog">
      <el-dialog :modal-append-to-body="false" :title="$t('devicecard.dowarn')" :visible.sync="imgDialog" class="imgDialog" width="50%" :before-close="handleClose">
        <template v-for="(item,index) in imgsrcDesc">
          <div :key="index">
            <img class="Dialogimg" :src="item.Value" v-if="item.Type === 'img'" />
            <div class="Dialogimg" v-if="item.Type==='txt'">{{ item.Value }}</div>
          </div>
        </template>

      </el-dialog>
    </template>-->
    <template v-if="is_slelectModifyName">
      <el-dialog
        :modal-append-to-body="false"
        class="remove_tree_cont"
        style="width: 100%; height: 100%"
        :visible.sync="is_slelectModifyName"
        width="100%"
        hight="100%"
        top="0px"
        :before-close="handleCloseSelectNameTag"
      >
        <div
          class="remove_tree slelectModifyBody"
          :style="
            'left:' +
              slelectModifyNamePointX +
              'px;top:' +
              slelectModifyNamePointY +
              'px;width:' +
              slelectModifyNameWidth +
              'px;height:' +
              slelectModifyNameHeight +
              'px;'
          "
        >
          <div class="blue_header">
            <span>{{ $t("install.slelectModifyNameCaption") }}</span>
          </div>
          <div
            v-for="(items, tag) in slelectModifyNameOptions"
            :key="tag"
          >
            <div class="slelectModifyNameCaption">
              {{ items.caption }}:
            </div>
            <div class="dataing_line">
              <span
                v-for="(item, index) in items.data"
                :key="index"
                class="week_list"
                :class="item.selected ? 'blueData' : ''"
                @click="islelectModifyNameCheck(item, 'selected', 'name')"
              >
                {{ item.name }}<img :src="data_select">
              </span>
            </div>
          </div>
          <div class="buttons">
            <!-- <el-button class="limite_button" @click="slelectModifyNameFinsh(curFlag)">{{ $t('devicecard.ok') }}</el-button> -->
            <button
              class="fleft"
              @click="is_slelectModifyName = false"
            >
              {{ $t("devicecard.cancel") }}
            </button>
            <button
              class="fright blueButton"
              @click="slelectModifyNameFinsh(curFlag)"
            >
              {{ $t("devicecard.ok") }}
            </button>
          </div>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import {
  FindCloudOtaVersionList,
  ChangeName,
  FindDevice,
  GetIdentifyInfo,
  PositiveIdentify,
  Replace,
  GetUIGuideDataList
} from "@/axios/IDevice.js";
import { alerterror, alertsuccess, warning } from "@/assets/js/common.js";
import {
  AddDevice,
  MoveDevice,
  ShowCurrentSyncResult,
  ReSyncAreaCode,
} from "@/axios/IArea.js";
import vMsg from "./deviceMsg.vue";
import vCds from "./courseDataySync.vue";
import radioTree from "./radioTree.vue";
import vChoose from "./deviceChoose.vue";
import img1 from "@/assets/img/icon-selected.png";
import Distinguish from "@/components/button/Distinguish";
import { catchRequireErr, getImgUrlState } from "@/utils/utils";
import { postWebIOSocket } from '@assets/socket';
import deviceSignalVue from './deviceSignal.vue';
import { GetStaticConfig, GetIsNeedOtaList } from "@/axios/ICommon.js";
import otaUpdateDidalog from '@/page/install/area/otaUpdateDidalog.vue'
import {parseVersionName} from '@/utils/parseVersionName.js'
import cloneDeep from 'lodash/cloneDeep'
import { getdeviceImageStatus } from '@/utils/utils'
import { DEVICE_ROLE } from '@/utils/enums.js'
import { OTAService } from '@/page/ota/utils/otaUpdate.js'






export default {
  name: "Card",
  components: {
    vMsg,
    vCds,
    radioTree,
    vChoose,
    Distinguish,
    deviceSignalVue,
    otaUpdateDidalog
  },
  props: {
    is_check: Boolean,
    cardlist: Array,
    isradio: Boolean,
    noclick: Boolean,
    isdel: Boolean,
    pageindex: Number,
    registerList: Array,
    isScrollRegist: Boolean,
    gpno: [String, Number],
    isExistGsDevice: Boolean,
    isFindGateway: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      DEVICE_ROLE,
      otaWarnFlag:false,
      versionList:null,
      deviceSelectedSku:[],
      needOtaUpdateList:[],
			dialogGroup: false, //控制弹出层显示隐藏
      pmodel: null, //点击移动删除回传回来的对象
      cousreTitle: "XXXX",
      checkedGpno: -1, //移动区域的gpno
      removecurrent: [], //需要移动的设备集合
      is_removetree: false, //显示隐藏移动区域选择
      courseDialog: false, //显示隐藏同步看板
      isloading: false, //是否加载
      editorModel: null, //修改名字的对象
      card_set: false, //显示隐藏设备详情组件
      model: null, //点击选项卡的对象
      imgDialog: false, //识别弹窗
      imgsrc: "", //被动识别图片
      imgsrcDesc: [], //被动识别图片描述
      // carddata: [],
      replaceid: 0, //替换设备id
      registInfo: null, //注册参数-设备信息
      registIdentify: null, //注册参数-设备识别
      isDoCardsetResresh: true, //是否可执行刷新
      ardsetResreshTotalTime: 1000, //执行刷新间隔5秒
      is_slelectModifyName: false, //修改设备名称-选标签
      slelectModifyNameOptions: [], //修改设备名称-选标签选项
      slelectModifyNamePointX: 0, //修改设备名称选标签窗口坐标X
      slelectModifyNamePointY: 100, //修改设备名称选标签窗口坐标Y
      slelectModifyNameWidth: 250, //修改设备名称选标签窗口宽度
      slelectModifyNameHeight: 320, //修改设备名称选标签窗口高度
      curFlag: null, //修改设备名称 - 所选择的临时对象
      data_select: img1,
      slelectModifyNameValue: [], //修改设备名称选标签窗口 确定的是名称
      handleblurTimeout: null, // 修改设备名称光标丢失
      isHandleblurTimeout: true,
      flag: false,
      newDeviceSelected:[],
      moveType:2,
      isLoadingReplace: false,
      hasSelectChildDevice: false, //是否子设备弹窗显示
    };
  }, //是否显示选择按钮 数据源 是否单选 是否不可点击 是否进行删除操作（控制回路不能删）
  computed: {
    socketmodel() {
      return this.$store.state.socketmodel //需要监听的数据
    },
    carddata() {
      //页面传递过来的数据
      // return this.registCard();
      if (this.cardlist == null || this.cardlist.length == 0) {
        this.isScrollRegist = false;
      }
      if (!this.isScrollRegist) {
        return this.registCard();
      } else {
        var temarry = [];
        this.cardlist.forEach((item) => {
          item["_DeviceName"] = item["DeviceName"] + "";
          this.formatedevicestatus(item);
					item.bleSignalPic = null
					if(item.IsOnline && item.StatusInfo != null){
						item.bleSignalPic = this.setBleSignal(item.StatusInfo)
					}
          temarry.push(item);
        });
        return temarry;
      }
    },
  },
  watch: {
    socketmodel (rs) {
      this.functionScoketsync_info_event(rs)
    },
    registerList(param) {

      //监听滚轴下滑传递过来的数据
      if (this.registInfo != null) {
        postWebIOSocket("sync_info_remove_event", this.registInfo);
      }
      if (this.registIdentify != null) {
        postWebIOSocket("sync_info_remove_event", this.registIdentify);
      }
      this.registInfo = null;
      this.registIdentify = null;
      if (param != null && param.length > 0) {
        this.cardRegisterMask(param);
        this.registInfo = { data: [] };
        this.registIdentify = { data: [] };
        param.forEach((n) => {
          if (n.VDeviceId != null && n.ChildId != null) {
            this.registInfo.data.push({
              projectCode: this.$store.state.projectcode,
              type: 1,
              id: n.VDeviceId,
            });
            this.registIdentify.data.push({
              projectCode: this.$store.state.projectcode,
              type: 3,
              id: n.Mac,
            });
          }
        });
        if (this.registInfo.data.length > 0) {
          postWebIOSocket("sync_info_add_event", this.registInfo);
        }
        if (this.registIdentify.data.length > 0) {
          postWebIOSocket("sync_info_add_event", this.registIdentify);
        }
      }
    },
  },
  destroyed() {
    console.log('页面销毁123');
    //页面销毁 删掉socket信息
    //socket.close();
    //socket.emit('sync_info_removeall_event');
    if (this.registInfo != null) {
      postWebIOSocket("sync_info_remove_event", this.registInfo);
    }
    if (this.registIdentify != null) {
      postWebIOSocket("sync_info_remove_event", this.registIdentify);
    }
  },
  mounted() {
    console.log('页面加载123');
      this.isDoCardsetResresh = true;
    // 		this.carddata = this.cardlist;
    //
    // 		var _arr = [];
    // 		var para = { data: [] };
    // 		var paramac={data: []};
    // 		var _arrmac=[];
    // 		var temarry = [];
    // 		this.carddata.forEach(n => {
    // 			if (n.VDeviceId && n.ChildId) {
    // 				_arr.push({ projectCode: this.$store.state.projectcode, type: 1, id: n.VDeviceId });
    // 				_arrmac.push({ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac });
    // 				this.formatedevicestatus(n);
    // 			}
    // 		});
    // 		para.data = _arr;
    // 		paramac.data=_arrmac;
    // 		if (para.data.length > 0) {
    // 			socket.emit('sync_info_add_event', para);
    // 			socket.emit('sync_info_add_event', paramac);
    // 		}
    // 		_arr = null;
    // 		para = null;
    // 		_arrmac=null;
    // 		paramac=null;
    //
    //socket.on('sync_info_event', this.functionScoketsync_info_event);
  },
  methods: {
    getdeviceImageStatus,
    parseVersionName:parseVersionName,
    setOtaWarnFlag(){
      this.otaWarnFlag = false
    },
     initOTaDialogData(){
      let total = JSON.parse(JSON.stringify(this.deviceSelectedSku))
      for(let index=0; index<total.length; index++){
        let firmList = JSON.parse(total[index].FirmVersionCollection)
        total[index].currentVersionList = []
        total[index].LatestVersionList = []
        for(let item of firmList){
          let _new = -1
          _new = this.findMatchVersion(total[index].ClassSku,item.SourceType)
          if(_new != -1){
            let curr = this.parseVersionName(item.Version)
            let latest = this.parseVersionName(_new)
            if(curr != latest){
              total[index].currentVersionList.push(curr)
              total[index].LatestVersionList.push(latest)
            }
          }
        }
      }
      this.newDeviceSelected = total.filter(item => item.currentVersionList.length>0)
      console.log('this.newDeviceSelected', this.newDeviceSelected)
    },
    findMatchVersion(classSku, type) {
      if(this.versionList != null){
        const matchedVersion = this.versionList[classSku];
        if (matchedVersion) {
          const result = matchedVersion.find(value => value.SourceType == type);
          if (result) {
            return result.CloudFirmwareVersion
          }
        }
      }
      return -1;
    },
    doRemoveArea(res){
      if(res){
        this.is_removetree = true
        setTimeout(()=>{
          this.otaWarnFlag = false
        },0)
      }
    },
    doGetStaticConfig(){
      GetStaticConfig({type:16},this.functionDoGetStaticConfig)
    },
    functionDoGetStaticConfig(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        try {
          if (rs.Result && rs.Result.Content) {
            let updateList = JSON.parse(rs.Result.Content);
            this.deviceSelectedSku.forEach(item => {
              this.isNeedOtaUpdate(item, updateList);
            });
            if (this.needOtaUpdateList.length > 0) {
              this.findCloudOtaVersionList();
            } else {
              this.is_removetree = true;
            }
          } else {
            this.is_removetree = true;
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    isNeedOtaUpdate(source,target){
      for (let [key1,value1] of Object.entries(target)) {
        let firmList = JSON.parse(source.FirmVersionCollection)
        if(source.ClassSku == key1 && firmList != null){
          firmList.forEach((item)=>{
            let hasValue1 = value1.filter(val => val.SourceType === item.SourceType)
            if(hasValue1.length>0 && item.Version < hasValue1[0].LowestVersion){
              this.needOtaUpdateList.push(source)
            }
          })
        }
      }
    },
    findCloudOtaVersionList(){
      let para = this.needOtaUpdateList.map(item => item.ClassSku)
      para = Array.from(new Set(para))
      FindCloudOtaVersionList(para,this.doFindCloudOtaVersionList)
    },
    doFindCloudOtaVersionList(res){
      this.versionList = res.Result
      this.initOTaDialogData()
      if(this.newDeviceSelected.length>0){
        this.otaWarnFlag = true
      }else{
        this.is_removetree = true;
      }
    },
		setBleSignal(_status){
      const targetItem = _status.find(item => item.StatusType === "0x1D01" && item.IsShow && item.Value !== '--' && item.Value !== '');
      if (targetItem) {
        return {
          maxSignal: +targetItem.Max,
          minSignal: +targetItem.Min,
          valueSignal: +targetItem.Value,
          nameSignal: targetItem.Name
        };
      }
      return null;
    },
    catchRequireErr,
    focusHandler(e) {
      console.log(e)
      e.currentTarget.select()
    },
    getImgUrlState:getImgUrlState,
    showHclTitle(val) {
      if (val == '3') {
        return this.$t('hcl.cardLightCCT')
      } else if (val == '1') {
        return this.$t('hcl.cardLight')
      } else if (val === '2') {
        return this.$t('hcl.cardCCT')
      } else {
        return this.$t('hcl.cardStop')
      }
    },
    //标记是否滚动注册 cardRegistermask = false
    cardRegisterMask(array, of) {
      if (array != null) {
        array.forEach((item) => {
          // item["StatusInfo"] = null;
          FindDevice(
            { vDeviceId: item["VDeviceId"], channelId: item["ChildId"] },
            this.functionDoFindDeviceRegisterMask
          );
        });
      }
    },
    // cardRegistermask
    cardRegisterMaskFind(array, cardRegistermask, of) {
      if (this.carddata != null) {
        return this.carddata.find((item) => {
          return (
            item && array &&
            item["VDeviceId"] == array["VDeviceId"] &&
            item["ChildId"] == array["ChildId"]
          );
        });
      }
    },
    functionDoFindDeviceRegisterMask(rs) {
      this.isloading = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        var _card = this.cardRegisterMaskFind(rs.Result);
        if (_card != null) {
          var _StatusInfo = rs.Result["StatusInfo"];
          _StatusInfo = JSON.parse(_StatusInfo);
          // 调整 BLE2 和 DALI 的顺序
          const ble2Index = _StatusInfo.findIndex(item => item.StatusType.toUpperCase() === '0X0107');
          const daliIndex = _StatusInfo.findIndex(item => item.StatusType.toUpperCase() === '0X0105');
          if (ble2Index > -1 && daliIndex > -1) {
            _StatusInfo.splice(daliIndex, 0, ..._StatusInfo.splice(ble2Index, 1));
          }
          
          _card["StatusInfo"] = _StatusInfo;
        }
        _card = null;
      }
    },
    onStop() {
    },
    islelectModifyNameCheck(item, tag, name) {
      item[tag] = !item[tag];
      var tagIndex = this.slelectModifyNameValue.indexOf(item[name]);
      if (item[tag] == true) {
        if (tagIndex < 0) {
          this.slelectModifyNameValue.push(item[name]);
        }
      } else if (tagIndex >= 0) {
          this.slelectModifyNameValue.slice(tagIndex, 0);
        }
    },
    slelectModifyNameFinsh(item) {
      if (item != null && this.slelectModifyNameValue.length > 0) {
        item["DeviceName"] = this.slelectModifyNameValue.join("");
        this.slelectModifyNameValue = [];
      }
      this.is_slelectModifyName = false;
    },
    makeCurFlagFalse(msg) {
      if (this.curFlag != null && this.curFlag != msg) {
        this.curFlag.flag = false;
      }
      this.curFlag = msg;
    },
    slelectModifyNameTag(event, msg) {
      this.slelectModifyNamePointY = event.y;
      this.slelectModifyNamePointX = event.x;

      if (
        this.slelectModifyNamePointY + this.slelectModifyNameHeight >
        window.innerHeight
      ) {
        this.slelectModifyNamePointY =
          window.innerHeight - this.slelectModifyNameHeight;
      }
      if (
        this.slelectModifyNamePointX + this.slelectModifyNameWidth >
        innerWidth
      ) {
        this.slelectModifyNamePointX = innerWidth - this.slelectModifyNameWidth;
      }
      this.is_slelectModifyName = true;

      this.slelectModifyNameValue = [];
      this.slelectModifyNameOptions = [];
      var _result;
      if (typeof msg.ParentAreaNames == "string") {
        _result = {
          caption: this.$t("devicecard.area"),
          data: [],
        };
        msg.ParentAreaNames.split(",").forEach((param) => {
          if (param != null && param != "") {
            _result.data.push({ name: param, selected: false });
          }
        });
        this.slelectModifyNameOptions.push(_result);
      }
      if (typeof msg.DeviceTypeName == "string") {
        _result = {
          caption: this.$t("install.deviceType"),
          data: [],
        };
        msg.DeviceTypeName.split(",").forEach((param) => {
          _result.data.push({ name: param, selected: false });
        });
        this.slelectModifyNameOptions.push(_result);
      }
      _result = null;
    },
    // getdeviceImageStatus(msg, type, value) {
    //   var result = null;
    //   if (msg != null && msg.StatusInfo != null) {
    //     msg.StatusInfo.forEach((model) => {
    //       /* 面板类型无开关状态，常开 */
    //       if(model.IsTop &&
    //         model.StatusType.toUpperCase().indexOf(type.toUpperCase()) >= 0 && type === '0X02' && msg.ChildCategoryType === 4){
    //         return true
    //       }

    //       if (
    //         model.IsTop &&
    //         model.StatusType.toUpperCase().indexOf(type.toUpperCase()) >= 0 &&
    //         (msg.ChildId != 65535 ? model.ChannelId == msg.ChildId : true) &&
    //         (msg.ChildId == 65535
    //           ? msg.ClassSku.toUpperCase() != "0X001C3003" 
    //           : true)
    //       ) {
    //         if (model["Value"] == value || model["Value1"] == value) {
    //           result = true;
    //         } else {
    //           result = false;
    //         }
    //       }
    //     });
    //   }
    //   return result;
    // },
    /**
     * 分解原始数据字段 doParentGpnos
     */
    doParentGpnos(device) {
      if (typeof device["ParentGpnos"] == "string") {
        //会归入父级所涉及区域
        var _ParentGpnos = device["ParentGpnos"];
        _ParentGpnos = _ParentGpnos && _ParentGpnos.replace(/@/g, "");
        _ParentGpnos = _ParentGpnos && _ParentGpnos.split(",");
        if (_ParentGpnos instanceof Array) {
          device["_ParentGpnos"] = _ParentGpnos.reverse();
        }
      }
    },
    /* 注册卡片socket信息 并且格式化card数据
     */
    registCard() {
      // const temp_list = cloneDeep(this.cardlist || [])
      const temp_list = this.cardlist
      if (this.$store.state.isregistersocket) {
        var _arr = [];
        var para = { data: [] };
        var paramac = { data: [] };
        var _arrmac = [];
        var temarry = [];
        var index = 0;
        var count = 0;
        if (this.pageindex) {
          count = (this.pageindex - 1) * 30;
        }
        temp_list.forEach((n) => {
					n.bleSignalPic = null
          n["_DeviceName"] = n["DeviceName"] + "";
          if (index >= count) {
            if (n.VDeviceId != null && n.ChildId != null) {
              _arr.push({
                projectCode: this.$store.state.projectcode,
                type: 1,
                id: n.VDeviceId,
              });
              _arrmac.push({
                projectCode: this.$store.state.projectcode,
                type: 3,
                id: n.Mac,
              });
              this.formatedevicestatus(n);
            }
          }
					if(n.IsOnline && n.StatusInfo != null){
						n.bleSignalPic = this.setBleSignal(n.StatusInfo)
					}
          temarry.push(n);
          index++;
        });

        para.data = _arr;
        paramac.data = _arrmac;
        if (para.data.length > 0) {
          postWebIOSocket("sync_info_add_event", para);
          postWebIOSocket("sync_info_add_event", paramac);
          !this.isFindGateway && this.$store.dispatch("changeIsregisterSocket", false);
          console.log('card修改了')
        }
        _arr = null;
        para = null;
        _arrmac = null;
        paramac = null;
        count = null;
        index = null;
        // console.log(temarry);
      } else {
        //deepwatch  return this.cardlist；
        temarry = [];
        temp_list.forEach((n) => {
					n.bleSignalPic = null
          this.formatedevicestatus(n);
					if(n.IsOnline && n.StatusInfo != null){
						n.bleSignalPic = this.setBleSignal(n.StatusInfo)
					}
          temarry.push(n);
        });
      }
      
      return temarry;
    },
    /* 格式化mac显示
     */
    /* 格式化mac显示
     * val：原始的mac值
     */
    macformate(val) {
      return formateMac(val);
    },
    /* 点击确认替换执行的方法
     * list：需要替换的设备数组
     */
    confirm(list) {
      if (this.isLoadingReplace) return;

      this.isLoadingReplace = true;

      var para = {
        vDeviceId: this.replaceid,
        otherVDeviceId: list[0].VDeviceId,
      };
      Replace(para, this.functionDoReplace);
      para = null;
    },
    /* 替换接口返回的数据处理
     * rs：返回的原始数据包
     */
    functionDoReplace(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.$emit("dosuccess", 2);
      } else {
        alerterror(this, rs.StatusCode);
      }
      this.dialogGroup = false;
      this.isLoadingReplace = false;
    },
    /* 点击替换显示弹出窗
     * item：当前的设备对象
     * */
    replacedevice(item) {
      this.replaceid = parseInt(item.VDeviceId);
      this.dialogGroup = true;
    },
    /* 获得移动的区域gpno
     * val：gpno值
     */
    getareaid(val) {
      //获得移动区域gpno
      this.checkedGpno = val;
    },
    /* 执行移动操作接口返回数据处理 不需要对接口数据做任何处理 直接弹出同步看板 同时关闭区域选择弹窗
     * rs：接口返回原始数据包
     * */
    functionDoNotice(rs) {
     
      this.is_removetree = false;
      //去掉同步看板
      // this.courseDialog = true;
      this.handleCloseSynCurrent();
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 将选中的设备移动到指定区域 如果设备在无区域使用/api/Area/AddDevice 反之/api/Area/MoveDevice
     */
    doremove() {
      this.removecurrent = [];
      var para = {};
      this.removecurrent.push({
        GpNo: this.checkedGpno,
        VDeviceId: this.pmodel.VDeviceId,
        ChannelId: this.pmodel.ChildId,
      });
      if (this.pmodel.Gpno == 0) {
        para.GpNo = this.checkedGpno;
        para.VDeviceId = this.pmodel.VDeviceId;
        para.ChannelId = this.pmodel.ChildId;
        AddDevice(para, this.functionDoNotice);
      } else if (this.checkedGpno != this.pmodel.Gpno) {
          para.srcGpNo = this.pmodel.Gpno;
          para.destGpNo = this.checkedGpno;
          para.vDeviceId = this.pmodel.VDeviceId;
          para.channelId = this.pmodel.ChildId;
          MoveDevice(para, this.functionDoNotice);
        } else {
          warning(this, this.$t("devicelist.warnmove"));
        }
      para = null;
    },
    /* 点击执行移动操作
     */
    finsh() {
      if (this.checkedGpno != -1) {
        // this.is_removetree = false;
        // this.courseing = true;
        this.doremove();
      } else {
        warning(this, this.$t("install.areacounterror"));
      }
    },
    /* 关闭移动弹窗
     */
    close() {
      this.is_removetree = false;
    },
    /* 关闭同步组件 向调用的窗体传返回值
     * done：组件自带属性 关闭弹窗
     */
    handleCloseSynCurrent(done) {
      done &&  done();
      this.model = null;
      this.card_set = false;
      this.$emit("dosuccess", 2);
    },
    /* 关闭弹窗公用方法
     * done：组件自带属性 关闭弹窗
     */
    handleClose(done) {
      done();
      // this.imgsrcDesc = [];
    },
    handleCloseSelectNameTag(done) {
      done();
      this.is_slelectModifyName = false;
    },
    /* 点击后台执行 通知调用组件
     */
    backgroundDoCurrent() {
      this.courseDialog = false;
      this.model = null;
      this.card_set = false;
      this.$emit("dosuccess", 2);
    },
    /* 点击弹出移动设备的区域树
     */
    removedevice(item) {
      this.deviceSelectedSku = []
      this.pmodel = item;
      this.needOtaUpdateList = []
      console.log('gpno', this.gpno)
      this.deviceSelectedSku.push(item)
      const otaService = new OTAService({
        setNeedOtaUpdateList: (list) => { this.needOtaUpdateList = list; },
        setNewDeviceSelected: (newDevices) => { this.newDeviceSelected = newDevices; },
        deviceSelectedSku: this.deviceSelectedSku,
        setOtaWarnFlag: (flag) => { this.otaWarnFlag = flag; },
        setRemovetreeDialogVisible: (visible) => { this.is_removetree = visible; }
      });
       // 有区域点开设备卡片详情
      if(this.gpno != 0){
        try {
          const tips = JSON.parse(getLocalStoragItem('tips') || '[]');
        
          if(tips.includes(item.VDeviceId)){
            this.is_removetree = true;
            return;
          }
       
           this.moveType = 1
           otaService.checkForOta('suggest', [this.deviceSelectedSku[0].VDeviceId]);
           //this.doGetIsNeedOtaList('suggest')
        } catch (error) {
          console.error(error);
        }
      } else {
        // 无区域点开设备卡片详情
        this.moveType = 2
        otaService.checkForOta('force', [this.deviceSelectedSku[0].VDeviceId]);
        //this.doGetIsNeedOtaList('force')
        // this.doGetStaticConfig()
      }
    },

    // 判断是否强制升级
    // doGetIsNeedOtaList(type){
    //   const param = {
    //     VDeviceIds: [this.deviceSelectedSku[0].VDeviceId],
    //     Type:type,
    //     AppType:4
    //   }
    //   GetIsNeedOtaList(param, this.functionDoGetIsNeedOtaList)
    // },
    
    // functionDoGetIsNeedOtaList(rs){
    //    if (rs.StatusCode == this.$store.state.rightStatusCode) {
    //     try {
    //       const otaInfo = rs.Result
    //       for (const id in otaInfo) {
    //           const items = otaInfo[id].filter(item => item.IsNeedOTA === true);
    //           this.needOtaUpdateList.push(...items);
    //       }
    //       if(this.needOtaUpdateList.length > 0){
    //         this.otaWarnFlag = true
    //         this.newDeviceSelected = this.findNeedOtaDeviceSelectedSku(otaInfo)
    //       }else{
    //         this.is_removetree = true;
    //       }
    //     } catch (error) {
    //       console.error(error);
    //     }
    //   }
    // },

    // findNeedOtaDeviceSelectedSku(data){
    //   const result = Object.entries(data)
    //       .filter(([vDeviceId, items]) => items.some(item => item.IsNeedOTA))
    //       .flatMap(([vDeviceId, items]) => {
    //           const otaItems = items.filter(item => item.IsNeedOTA);
    //           const relatedSku = this.deviceSelectedSku.find(sku => sku.VDeviceId === vDeviceId);
    //           return otaItems.map(otaItem => ({
    //               ...otaItem,
    //               vDeviceId,
    //               DeviceName: relatedSku?.DeviceName,
    //               DeviceTypeName: relatedSku?.DeviceTypeName,
    //               Mac: relatedSku?.Mac,
    //               ClassSku: relatedSku?.ClassSku,
    //               LocalVersion:this.parseVersionName(otaItem.LocalVersion),
    //               LatestVersion:this.parseVersionName(otaItem.LatestVersion)
    //           }));
    //       });

    //     return result

    // },
    /* 点击弹出删除设备确认 并对参数赋值
     */
    deletedevice(item) {
      this.pmodel = item;
      this.removecurrent.push({
        GpNo: this.pmodel.Gpno,
        VDeviceId: this.pmodel.VDeviceId,
        ChannelId: this.pmodel.ChildId,
      });
      //去掉同步看板
      // this.courseDialog = true;
      this.handleCloseSynCurrent();
    },
    /* socket推送处理方法
     * rs：推送过来的原始数据包
     */
    functionScoketsync_info_event(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result[0].Type == 3) {
          //被动识别
          // this.imgDialog = false;
          this.carddata.forEach((n) => {
            if (n.Mac == rs.Result[0].DeviceMac) {
              n.isflicker = true;
              //socket.emit('sync_info_remove_event', { data: [{ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac }] });
              setTimeout(() => {
                n.isflicker = false;
              }, 2000);
            }
          });
        } else if (rs.Result[0].Type == 15) {
          //修改名称d

          this.carddata.forEach((n) => {
            if (
              n.VDeviceId == rs.Result[0].Id &&
              n.ChildId == rs.Result[0].ChannelId
            ) {
              if (n.ChildId == 65535) {
                n.DeviceName = rs.Result[0].SyncInfo;
              } else {
                n.ChildName = rs.Result[0].SyncInfo;
              }
            }
          });
        } else if (rs.Result[0].Type == 11) {
          this.carddata.forEach((h) => {
            if (h.VDeviceId == rs.Result[0].VDeviceId) {
              rs.Result[0].StatusInfo.forEach((n) => {
                if (h.StatusInfo) {
                  h.StatusInfo.forEach((m) => {
                    // if (m.StatusCode == n.StatusCode) {
                    // 	m.Value = n.Value;
                    // }
                    // if (m.StatusCode == '0x0000') {
                    // 	h.IsOnline = n.Value == '0x0000' ? true : false;
                    // }
                    if (
                      m.StatusType == n.StatusType &&
                      m.ChannelId == n.ChannelId
                    ) {
                      m.Value = n.Value;
                      if (
                        m.StatusType == "0x1600" ||
                        m.StatusType == "0x1601"
                      ) {
                        m["ParaUnit"] = "s";
                      }
                    }
                    if (m.StatusCode == "0x0100") {
                      h.IsOnline = n.Value == "1";
                    }
                  });
                }
              });

              this.formatedevicestatus(h);
              // this.$forceUpdate();//强制渲染

              // this.getDeviceStateUrl(h.StatusInfo, h, icon_type03);
              // this.getDeviceStateTitle(h.StatusInfo, h);
            }
          });
        } else if (rs.Result[0].Type == 10) {
          //在线状态
          this.carddata.forEach((n) => {
            if (n.VDeviceId == rs.Result[0].VDeviceId) {
              n.IsOnline = rs.Result[0].IsOnline;
            }
          });
        } else if (rs.Result[0].Type == 13) {
          //移动状态（同步中）

          this.carddata.forEach((n) => {
            if (n.VDeviceId == rs.Result[0].VDeviceId) {
              n.InAreaResultCode = rs.Result[0].InAreaResultCode;
            }
          });
        }
      }
    },
    /* 格式化设备数据
     * item：设备对象
     */
    formatedevicestatus(item) {
      //格式化设备状态
      if (item.StatusInfo) {
        if (item.StatusInfo != null && item.StatusInfo != "") {
          item.StatusInfo.forEach((n) => {
            if (n.StatusType == "0x0600") {
              this.getilluminationValue(n);
            } else if (n.StatusType == "0x0700") {
              this.gettemperatureValue(n);
            } else if (n.StatusType == "0x1600" || n.StatusType == "0x1601") {
              //上电时长/开灯时长 界面将秒转成小时
              this.getpowertimeValue(n);
            }
            const keyMap = Object.create(null);
            this.$store.state.deiveStatus.forEach(el => { keyMap[el.Key] = el });
            const m = keyMap[n.StatusType] || keyMap[n.StatusType.substring(0, 4)];
            if (m) {
              //校准匹配 isReturn = true;
              m.Value.forEach((t) => {
                if (t.Value != undefined) {
                  if (t.Value == n.Value) {
                    n.Value1 = n.Value;
                    n.Value = t.Key;
                    n.ParaUnit = "";
                  }
                }
              });
            }
          });
          
        }
      }
    },
  
    /* 注册socket
     * model：设备对象
     */
    dosocket(model) {
      var para = {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 3,
            id: model.Mac,
          },
        ],
      };
      postWebIOSocket("sync_info_add_event", para);
      para = null;
    },
    /* 修改设备名称接口返回数据处理
     * rs：接口原始数据包
     */
    functionDoChangeName(rs, param) {
      var item = this.carddata.find((p) => {
        return (
          p["VDeviceId"] == param["vDeviceId"] &&
          p["ChildId"] == param["channelId"]
        );
      });
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.triggerSocketName(item);
      } else {
        item["DeviceName"] = item["_DeviceName"] + "";
        alerterror(this, rs.StatusCode);
      }
      item = null;
    },
    /* 修改完设备名称以后 通知socket广播
     */
    triggerSocketName(item) {
      if (item == null) {
        return;
      }
      item["_DeviceName"] = item["DeviceName"] + "";
      var para = {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 15,
            id: item.VDeviceId,
            channelId: item.ChildId,
            syncInfo: item.ChildId == 65535 ? item.DeviceName : item.ChildName,
          },
        ],
      };
      // console.log(para);
      postWebIOSocket("sync_info_trigger_event", para);
      para = null;
    },
    /* 执行修改设备名称动作
     */
    doChangeName(msg) {
      var para = {
        vDeviceId: this.editorModel.VDeviceId,
        channelId: this.editorModel.ChildId,
        newName:
          this.editorModel.ChildId == 65535
            ? this.editorModel.DeviceName
            : this.editorModel.ChildName,
        oldName:
          this.editorModel.ChildId == 65535
            ? this.editorModel._DeviceName
            : this.editorModel.ChildName,
        location: 0,
      };
      ChangeName(para, this.functionDoChangeName, msg);
      para = null;
    },
    handleblur(msg, event) {
      if (/(,|，)/g.test(msg.DeviceName)) {
        // warning(this, this.$t("devicecard.noComma").replace(/#,#/g, ','));
        this.isHandleblurTimeout == true;
      }

      if (this.isHandleblurTimeout == true) {
        this.handleblurTimeout = setTimeout(this.handleblurTimeoutDo, 300, msg);
      }
      this.isHandleblurTimeout = true;
    },
    handleblurTimeoutDo(param) {
      param.DeviceName = param["_DeviceName"] + "";
      param.flag = false;
    },
    /* 按回车执行修改名称
     * msg:设备对象
     */
    handleEnter(msg, event) {
      this.editorName(msg, event);

      // this.edit(msg);
      this.isHandleblurTimeout = false;
    },
    /* 点击执行修改名称
     * msg:设备对象
     */
    edit(msg, event) {
      this.isHandleblurTimeout = true;
      this.editorName(msg, event);
      this.makeCurFlagFalse(msg);
    },
    /* 点击执行修改名称
     * msg:设备对象
     */
    editorName(msg, event) {
      if (msg.flag) {
        if (msg.DeviceName === '') {
          warning(this, this.$t("devicecard.nonametip"));
          event.currentTarget.focus();
          msg.DeviceName = msg._DeviceName;
          return;
        }
        if (/(,|，)/g.test(msg.DeviceName)) {
          warning(this,  this.$t("devicecard.noComma").replace(/#,#/g, ','));
          // event.currentTarget.focus();
          // msg.DeviceName = msg.ClassSkuName;
          clearTimeout(this.handleblurTimeout);
          return;
        }

        msg.flag = false;
        clearTimeout(this.handleblurTimeout);
        this.editorModel = msg;
        this.doChangeName(msg);

        return
      }

      msg.flag = true;
      var d = event["currentTarget"];
      if (d["tagName"] == "BUTTON") {
        d = d && d["previousElementSibling"];
        d = d && d["previousElementSibling"];
      }
      setTimeout(function () {
        d.focus();
        d = null;
      }, 100);
    },
    /* 关闭设备详情
     */
    cardCloce() {
      this.model = null;
      this.card_set = false;
    },
    /* 点击弹窗设备详情
     */
    cardset(val) {
      if (val == null) {
        // && val.flag != null && val["flag"] == true){
        return;
      }
      if (val["flag"] == true || this.flag) {
        return;
      }

      if (this.is_check) {
        //点击选中选项卡
        this.cliclChoose(val);
        this.$emit("removeTree", [this.carddata, val]);
      } else if (!this.noclick) {
          this.model = val;
          this.card_set = true;
          //this.doFindDevice(val.VDeviceId,val.ChildId);
        }
    },
    /* 设备详情接口返回数据处理
     * rs:接口返回原始数据包
     */
    functionDoFindDevice(rs) {
      this.isloading = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.model = rs.Result;
        this.card_set = true;
      }
    },
    /* 去查找设备详情
     * vid:vDeviceId 设备虚拟id
     * cid:channelId 回路号
     */
    doFindDevice(vid, cid) {
      //获得设备详情
      this.isloading = true;
      var para = { vDeviceId: vid, channelId: cid };
      FindDevice(para, this.functionDoFindDevice);
      para = null;
    },
    /* 点击设备卡选择谁被 区分单选多选
     * val:设备对象
     */
    doclickchoose(val) {
      this.$emit('onClickChoose', val, val.ischecked)
      if (this.isradio) {
        if (!val.ischecked) {
          val.ischecked = !val.ischecked;
        }
      } else if (!val.isdisabled) {
          val.ischecked = !val.ischecked;
        }
    },
    /* 点击设备卡选择谁被 区分单选多选 如果是删除模式下 需要判断是不是回路 回路不可被删除
     * val:设备对象
     */
    cliclChoose(val) {
      if (this.isdel) {
        if (val.ChildId == 65535) {
          this.doclickchoose(val);
        } else {
          warning(this, this.$t("devicecard.delDeviceInfo"));
        }
      } else {
        this.doclickchoose(val);
      }
    },
    /* 通知调用组件
     * val:传递的值
     */
    removeTree(val) {
      this.cliclChoose(val);
      this.$emit("removeTree", [this.carddata, val]);
    },
    /* 通知调用组件
     * val:传递的值
     */
    dosuccess(val,show = false) {
      this.model = null;
      this.card_set = show;
      this.$emit("dosuccess", val);
    },
    cardsetResresh() {
      if (!this.isDoCardsetResresh) {
        return;
      }
      this.isDoCardsetResresh = false;
      let ardsetResreshTotalClock = window.setInterval(() => {
        this.ardsetResreshTotalTime--;
        if (this.ardsetResreshTotalTime < 0) {
          window.clearInterval(ardsetResreshTotalClock);
          this.ardsetResreshTotalTime = 1000;
          this.isDoCardsetResresh = true;
        }
      });
      var dd = this.$refs.cardsetObj.mountedDo;
      if (typeof dd == "function") {
        dd(true);
      }
      dd = null;
    },
    selectChildDevice(val){
      this.hasSelectChildDevice = val
    }
  },
};
</script>

<style lang="scss" scoped>
/* 设备卡片样式	 */
// .card_list:hover{
//   border: solid 1px #dde8f7;
//   border-radius: 20px;
// }
.op_relative {
  position: relative;
}
.op_mt40 {
  margin-top: 36px;
  /*display: inline-block;*/
}
.op_w130 {
  width: 130px;
}
.card_tianmu{
  // border: 1px solid #417FE3;
  padding: 2px;
}
.op_cardname {
  display: flex;
  left: 0px;
  align-items: center;
  position: absolute !important;
  width: auto !important;
  max-width: 160px !important;
}
.op_cardname_tianmu{
  display: flex;
  justify-content: center;
  max-width: 60% !important;
  left: 20% !important;
  right: 0px !important;
}
.op_cardname_tianmu .card_title{
  text-align: center;
  width: auto !important;
}

.text-ellipsis,
.text-ellipsis div {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.op_static {
  position: static !important;
}
.card_list {
  display: inline-block;
  cursor: pointer;
  border-radius: 3px;
  float: left;
  position: relative;
  // -webkit-transition: all 1s;
  // transition: all 1s;
  .card_header {
    /*border-radius: 3px 3px 0px 0px;*/
    height: 108px;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    .card_badge {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1;
      i {
        position: absolute;
        z-index: 1;
        color: #fff;
        width: 31px;
        height: 40px;
        left: 9px;
        top: 4px;
        text-align: center;
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);

        filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.45);
        font-size: 11px;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &:after {
        position: absolute;
        content: "";
        width: 0px;
        height: 0px;
        border-color: transparent thistle;
        border-width: 0px 0px 40px 40px;
        border-style: solid;
        left: 0px;
        top: 0px;
      }
    }
    .bgcolor1 {
      &:after {
        border-color: transparent #a39ce2;
      }
    }
    .bgcolor2 {
      &:after {
        border-color: transparent #92a1e4;
      }
    }
    .bgcolor3 {
      &:after {
        border-color: transparent #97b0d4;
      }
    }
    .bgcolor4 {
      &:after {
        border-color: transparent #a2c0c8;
      }
    }
    .bgcolor5 {
      &:after {
        border-color: transparent #92a1e4;
      }
    }
    .bgcolor6 {
      &:after {
        border-color: transparent #a2acc8;
      }
    }
    .bgcolor7 {
      &:after {
        border-color: transparent #a2bcc8;
      }
    }
  }
}
.card_header_msg {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  .card_left {
    width: 35%;
    display: inline-block;
    box-sizing: border-box;
    float: left;
    position: relative;
    height: 100%;
    .card_img {
      height: 43px;
      display: block;
      margin: 0 auto;
      margin-top: 35px;
    }
    .link_img {
      /*
			left: 16px;
      bottom: 8px;
      */
      position: absolute;
      left: 11px;
      top: 26px;
      height: 13px;
    }
  }
  .card_right {
    color: $color6;
    display: inline-block;
    width: 65%;
    box-sizing: border-box;
    margin-top: 13px;
    .card_title {
      width: 100%;
      line-height: 30px;
    }
    li {
      width: 50%;
      display: inline-block;
      float: left;
      height: 20px;
      margin-bottom: 8px;
      span {
        color: $color5;
      }
      button {
        width: 40px;
        height: 18px;
        border-radius: 3px;
        border: solid 1px $color6;
        line-height: 18px;
        padding: 0px;
        color: $color6;
        background: transparent;
        span {
          color: $color6;
        }
      }
    }
  }
}
.real {
  background: linear-gradient(-45deg, #dbe6fe, #e9f1ff);
}
.fake {
  background: linear-gradient(-45deg, #dbe9fa, #ebf4ff);
}

.card_input {
  font-size: 12px;
  color: $color6;
  position: relative;
  width: 100px;
  height: 25px;
  margin-bottom: 10px;
  button {
    margin-left: 5px;
  }
  input {
    display: inline-block;
    border: 1px solid $color6;
    background: transparent;
    height: 100%;
    color: $color6;
    position: absolute;
    width: 100%;
    text-indent: 10px;
    font-size: 12px;
    border-radius: 3px;
    outline: none;
  }
}
.have_date {
  position: absolute;
  top: 5px;
  right: 15px;
}
.have_new {
  position: relative;
  img {
    position: absolute;
    right: 0px;
    top: -20px;
  }
  button {
    width: 100%;
    height: 30px;
    border-radius: 3px;
    border: solid 1px #ced3db;
    font-size: 13px;
    background: #fff;
    color: #8a94a4;
    cursor: pointer;
    &:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}
.card_list {
  .shadow_box {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
.icon-43 {
  color: #6fa2ea;
  font-size: 16px;
}
.icon-15 {
  font-size: 18px;
  color: #a8b9d1;
}
.icon-45 {
  color: #2481ea;
  font-size: 14px;
}
.icon-37 {
  color: #2481ea;
  font-size: 14px;
}
.icon--96 {
  color: #2481ea;
  font-size: 14px;
}
.icon-18 {
  font-size: 18px;
  color: #ff5952;
}
.card_dialog {
  .buttonRefresh {
    right: 60px;
    position: absolute;
    top: 18px;
    padding: 3px 8px;
  }
}

.card_list_big {
  width: 224px;
  height: 215px;
  background: rgba(254, 254, 254, 1);
  border: 1px solid rgba(221, 226, 234, 1);
  border-radius: 3px;
  .card_msgs {
    width: 184px;
    height: auto;
    padding: 15px 20px;
    position: absolute;
    bottom: 0;
    background: #fefefe;
    ul {
      margin: 10px 0;
      margin-top: 0;
      li {
        height: 20px;
        line-height: 20px;
        margin: 0;
        &:first-child {
          display: none;
        }
      }
    }
    &:hover {
      ul li:first-child {
        display: block;
      }
    }
  }
  .card_header {
    width: 224px;
    height: 125px;
    background: rgba(215, 230, 250, 1);
    margin: 0;
    .card_badge {
      // display: none;
    }
    .card_isbind {
      position: absolute;
      height: 13px;
      right: 10px;
      top: 3px;
      z-index: 1;
      .third{
      border-radius: 5px;
      background: rgba(79, 150, 255, 1);
      padding: 2px 4px;
      color:#fff;
      font-size: 12px
    }
    }
    .card_isbind_check{
      right: 25px;
    }
    .card_state{
      margin-bottom: 5px;
    }
    .car_statusInfo {
      float: left;
      font-size: 12px;
      z-index: 1;
      transform: scale(0.7);
      .statusCssPerson {
        display: flex;
        height: 12px;
        line-height: 12px;
        font-size: 13px;
        background: linear-gradient(180deg, #046EE5 0%, #50A1FD 100%);
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.25);
        border-radius: 2px;
        padding: 2px;
        margin-bottom: 5px;
        color: #ffffff;
      }
      .statusCssPersonNone {
        background: linear-gradient(180deg, #A5A5A5 0%, #C4C4C4 100%);
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.25);
      }
    }
    .card_header_msg {
      width: 100%;
      height: 100%;
      background: transparent !important;
      .modifyNameCss {
        position: absolute;
        right: 25px;
        display: block;
        padding: 5px;
        background: rgba(255, 255, 255, 0.01);
      }
      .card_left {
        height: 70px;
        overflow: hidden;
        width: 100%;
        .card_img {
          margin: 0 auto;
          margin-top: 20px;
        }
      }
      .card_right.op_relative {
        margin: 0;
        height: 53px;
        width: 100%;
        .card_input.op_cardname {
          margin: 0;
          height: 30px;
          position: absolute !important;
          left: 35px;
          top: -8px;
          .card_title.text-ellipsis.op_static {
            height: 30px;
          }
        }
        .card_state_body {
          margin: 0 auto;
          width: fit-content;
          margin-top: 24px;

          .card_state.op_mt40 {
            width: auto;
            height: 23px;
            margin: 0 !important;
            text-align: center;
            li {
              position: relative;
              width: auto;
              margin: 0 3px;
              max-width: 33%;
              min-width: 54px;
              height: 100%;

              display: flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              span {
                width: auto;
                display: inline-block;
                min-width: 50px;
              }
              em {
                /*margin: 4px 20px;*/
                margin: 0;
                right: 0;
              }
            }
          }
        }
      }
    }
    .el-checkbox__inner {
      border-radius: 50px;
    }
  }

  &.disableCheck {
    // pointer-events: none;
    cursor: not-allowed;
  }
}
.slelectModifyDialog {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
  width: 100%;
  height: 100%;
}

.slelectModifyBody {
  width: 300px;
  height: 400px;
  margin: 0;
  position: absolute;
  left: 0;
  top: 0;
  .buttons {
    width: 180px;
    margin: 0 auto;
    button {
      width: 88px;
      height: 32px;
      border-radius: 3px;
      border: solid 1px #4f8ee7;
      margin-top: 13px;
      color: #4f8ee7;
      background: #fff;
    }
    button.blueButton {
      background-color: #0046aa;
      color: #fff;
      border-color: #0046aa;
    }
  }

  .blue_header {
    text-indent: 18px;
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
  }
  .slelectModifyNameCaption {
    line-height: 40px;
    text-indent: 18px;
    margin-top: 5px;
    font-size: 14px;
    font-weight: 500;
  }
  .dataing_line {
    width: auto;
    margin: 0;
    margin-bottom: 10px;
    padding: 0 17px;
    max-height: 80px;
    overflow: hidden;
    span {
      width: auto;
      max-width: 70px;
      height: 25px;
      line-height: 25px;
      padding: 3px 10px;
      margin-bottom: 5px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .limite_button {
    margin-top: 0;
  }
}
// .otaWarn_box{
//   top: 15%;
// }
.otaWarn_box.el-dialog__wrapper{
  overflow: hidden; 
}
</style>
